const FilesHandler = {
    /**
     * Gets mime types
     * @returns {Object}
     */
    getMimeTypes() {
        return {
            'image/jpeg': '.jpg',
            'image/png': '.png',
            'image/gif': '.gif',

            'text/plain': '.txt',

            'application/pdf': '.pdf',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': '.xlsx',
            'application/vnd.ms-excel': '.xls',
            'application/vnd.ms-powerpoint': '.ppt',
            'application/vnd.openxmlformats-officedocument.presentationml.presentation': '.pptx',

            'video/mp4': '.mp4',
            'video/x-matroska': '.mkv',
            'video/quicktime': '.mov',
            'video/webm': '.webm',
            'video/avi': '.avi',
            'video/x-msvideo': '.avi',
            'video/x-flv': '.flv',
            'video/x-ms-wmv': '.wmv',
            'video/mpeg': '.mpg',
            'video/3gpp': '.3gp',
            'video/3gpp2': '.3g2',
            'video/ogg': '.ogv'
        };
    }
}

export default FilesHandler;